import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import $ from 'jquery';
import VueSplide from '@splidejs/vue-splide';
import VueGallerySlideshow from 'vue-gallery-slideshow';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm';
import { ValidationObserver } from 'vee-validate';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import './bus';
import '@/assets/fb_sdk';
import '@/assets/layout.scss';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.config.productionTip = false;
Vue.prototype.$ = $;
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueSplide);
Vue.use(VueGallerySlideshow);
Vue.use(CKEditor);

/* eslint-disable */
Date.prototype.yyyymmdd = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd,
         ].join('');
};

Date.prototype.msCode = function() {
  let mm = this.getMonth() + 1; // getMonth() is zero-based
  let dd = this.getDate();
  let hr = this.getHours();
  let min = this.getMinutes();
  let sec = this.getSeconds();
  let msec = this.getMilliseconds();

  return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd,
          hr, min, sec, msec,
         ].join('');
};
/* eslint-enable */

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
